export default class CategoryComponent extends HTMLElement {
    constructor() {
        super();

        this.currentIndex = 0;
        this.isScrolling = false;
        this.scrollTimeout;
        this.observer = this.querySelector('[data-category-component-observer]');
        this.list = this.querySelector('[data-category-component-list]');
        this.items = this.querySelectorAll('[data-category-component-link]');
        this.images = this.querySelectorAll('[data-category-component-image]');
        this.active = this.querySelector('[data-category-component-link].active');
        this.previous = this.querySelector('[data-category-component-previous]');
        this.next = this.querySelector('[data-category-component-next]');
        this.pagination = this.querySelector('[data-category-component-pagination]');
        this.hovered;
    }

    _setButtonsState() {
        this.previous.disabled = this.currentIndex === 0;
        this.next.disabled = this.currentIndex === this.items.length - 1;
    }

    _setPagination() {
        this.pagination.innerText = ('0' + (this.currentIndex + 1)).substr(-2);
    }

    _setPositionByIndex() {
        const box = this.list.getBoundingClientRect();
        const targetBox = this.items[this.currentIndex].getBoundingClientRect();

        window.scrollTo(0, targetBox.top - box.top);
    }

    _calculateScrollPosition() {
        const scrollTop = window.pageYOffset;
        const box = this.list.getBoundingClientRect();
        const lineHeightOffset = parseInt(window.getComputedStyle(this.items[0], ':before').height) / 2;
        const targetY = scrollTop + box.top + lineHeightOffset;

        const closest = Array.prototype.slice.call(this.items).reduce(function (previous, current) {
            const currentBox = current.getBoundingClientRect();
            const previousBox = previous.getBoundingClientRect();
            const currentY = currentBox.top + currentBox.height / 2;
            const previousY = previousBox.top + previousBox.height / 2;
            return Math.abs(currentY - targetY) < Math.abs(previousY - targetY) ? current : previous;
        });

        this.isScrolling = true;
        this.classList.add('scrolling');
        clearTimeout(this.scrollTimeout);

        if (this.active !== closest) {
            this.currentIndex = +closest.dataset.index;
            this.active.classList.remove('active');
            this.hovered?.classList.remove('active');
            closest.classList.add('active');
            this.active = closest;
            this._setButtonsState();
            this._setPagination();
        }
        this.scrollTimeout = setTimeout(() => {
            this.isScrolling = false;
            this.classList.remove('scrolling');

            this.style.backgroundColor = this.active.dataset.color;
            this.querySelector('[data-category-component-image].active').classList.remove('active');
            this.images[this.active.dataset.index].classList.add('active');
        }, 100);
    }

    _init() {
        window.addEventListener('resize', () => {
            this._calculateScrollPosition();
        });

        window.addEventListener('orientationchange', () => {
            this._calculateScrollPosition();
        });

        window.addEventListener(
            'scroll',
            (e) => {
                this._calculateScrollPosition();
            },
            false
        );

        if (/Mobi/.test(navigator.userAgent) === false) {
            this.items.forEach((target, index) => {
                target.addEventListener('mouseover', () => {
                    this.hovered = target;
                    this.active.classList.remove('active');
                    this.hovered.classList.add('active');
                    this.querySelector('[data-category-component-image].active').classList.remove('active');
                    this.images[this.hovered.dataset.index].classList.add('active');
                    this.style.backgroundColor = target.dataset.color;
                });
                target.addEventListener('mouseout', () => {
                    this.hovered?.classList.remove('active');
                    this.active.classList.add('active');
                    this.querySelector('[data-category-component-image].active').classList.remove('active');
                    this.images[this.active.dataset.index].classList.add('active');
                    this.style.backgroundColor = this.active.dataset.color;
                    this.hovered = undefined;
                });
            });
        }

        this.previous.addEventListener('click', () => {
            this.currentIndex = Math.max(0, this.currentIndex - 1);
            this._setPositionByIndex();
        });

        this.next.addEventListener('click', () => {
            this.currentIndex = Math.min(this.items.length - 1, this.currentIndex + 1);
            this._setPositionByIndex();
        });
    }

    connectedCallback() {
        this._init();
    }

    disconnectedCallback() {}
}

customElements.define('category-component', CategoryComponent);
